import type { Theme } from "@mui/material/styles";
import { MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX } from "./management-toolbar.constants";

/**
 * MUI Select / FormControl height matching weekday, booking-type, and unit toggles.
 */
export const managementToolbarSelectSx = {
  "& .MuiOutlinedInput-root": {
    height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: "100%",
    py: 0
  }
} as const;

/**
 * Mobiscroll outline textfield sized and typed like MUI toolbar selects.
 */
export function managementToolbarMobiscrollOutlineSx(theme: Theme) {
  return {
    width: "100%",
    minWidth: 0,
    "& .mbsc-material.mbsc-textfield-wrapper": {
      m: 0,
      width: "100%"
    },
    "& .mbsc-textfield-wrapper-outline": {
      height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
      minHeight: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX
    },
    "& .mbsc-textfield-inner-outline": {
      height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
      minHeight: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
      boxSizing: "border-box",
      borderRadius: `${theme.shape.borderRadius}px`,
      borderColor:
        theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",
      bgcolor: "background.paper"
    },
    "& .mbsc-textfield-wrapper-outline:hover .mbsc-textfield-inner-outline": {
      borderColor: theme.palette.text.primary
    },
    "& .mbsc-focus .mbsc-textfield-inner-outline": {
      borderColor: theme.palette.primary.main,
      borderWidth: 2
    },
    "& input.mbsc-textfield": {
      height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
      minHeight: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
      boxSizing: "border-box",
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body2.fontSize,
      lineHeight: 1.43,
      color: theme.palette.text.primary,
      py: 0
    }
  } as const;
}
